<template>
  <div>
    <Navbar></Navbar>
    <main>
      <FullLoader :loading="createLoading"/>
      <div class="container create-prize-container">
        <div class="row">
          <div class="col-12 d-flex justify-content-between align-items-center page-header">
            <img
              @click="backToDashboard()"
              class="header-action cancel"
              src="@/assets/images/x.svg"
            >
            <h1>
              {{event_name}}
              <img class="path-separator" src="@/assets/images/path_separator.svg">
              <span>Prizes</span>
              <img class="path-separator" src="@/assets/images/path_separator.svg">
              <span class="new">{{prizeText}}</span>
            </h1>
            <div class="desktop">
              <button class="btn btn-primary" @click="validate()">{{prizeAction}}</button>
            </div>
          </div>

          <div class="col-6">
            <form style="padding-top: 35px">
              <div class="form-group">
                <label for="prizeName" class="required">Prize Name</label>
                <!-- <span class="icon-info prize-name" @click="toggleHelperText('prize_name')">
                <span v-if="showPrizeNameInfo">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500</span>
                </span>-->
                <input
                  type="text"
                  v-model="prizeName"
                  class="form-control"
                  id="prizeName"
                  placeholder="Gold or Bronze"
                  required="true"
                >

                <p class="error-message">{{this.errors.emptyname}}</p>
                <p class="error-message">{{this.errors.lengthGreaterThanThirty}}</p>
                <p class="error-message">{{this.errors.invalidName}}</p>
              </div>
              <div class="form-group">
                <label for="winners" class="required">Number of Winners</label>
                <!-- <span class="icon-info winners" @click="toggleHelperText('winners')">
                <span v-if="showWinnersInfo">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500</span>
                </span>-->
                <input
                  type="number"
                  v-model="winnerCount"
                  min="1"
                  max="999"
                  step="1"
                  maxlength="3"
                  pattern="\d{3}"
                  class="form-control"
                  id="winners"
                  placeholder="Between 1 - 999"
                  required="true"
                >
                <p class="error-message">{{this.errors.count}}</p>
              </div>
              <div class="form-group">
                <label for="attendeesDropdown" class="required">Attendees List(s)</label>
                <!-- <span class="icon-info attendeesDropdownInfo" @click="toggleHelperText('attendees_dropdown')">
                <span v-if="showattendeesDropdownInfo">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500</span>
                </span>-->
                <div class="attendees-dropdown-container dropdown withInput">
                  <div data-toggle="dropdown">
                    <input
                      type="search"
                      class="form-control"
                      id="attendeesDropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      v-model="listname"
                    >
                    <p class="error-message">{{this.errors.lists}}</p>
                    <span class="caret-container">
                      <img src="@/assets/images/caret.svg">
                    </span>
                  </div>
                  <div class="dropdown-menu list-container" aria-labelledby="dropdownMenuButton">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" value="all_attendees" v-model="all_attendees">
                        <img
                          v-if="all_attendees.length > 0"
                          class="checkbox-square"
                          src="@/assets/images/square_check.svg"
                        >
                        <img
                          v-else
                          class="checkbox-square"
                          src="@/assets/images/square_uncheck.svg"
                        >
                        All Attendees
                      </label>
                    </div>
                    <div v-if="this.static_lists.length > 0" class="list-section">Static Lists</div>
                    <div
                      v-for="(list) in static_list_filter"
                      :key="'static_'+list._id"
                      class="checkbox"
                    >
                      <label v-show="display">
                        <input type="checkbox" :value="list" v-model="static_selected">
                        <img
                          v-if="static_selected.indexOf(list) == -1"
                          class="checkbox-square"
                          src="@/assets/images/square_uncheck.svg"
                        >
                        <img v-else class="checkbox-square" src="@/assets/images/square_check.svg">
                        {{ list.name }}
                      </label>
                    </div>
                    <div v-if="this.smart_lists.length > 0" class="list-section">Smart Lists</div>
                    <div
                      v-for="(list) in smart_lists_filter"
                      :key="'smart_'+list._id"
                      class="checkbox"
                    >
                      <label v-show="display">
                        <input type="checkbox" :value="list" v-model="smart_selected">
                        <img
                          v-if="smart_selected.indexOf(list) == -1"
                          class="checkbox-square"
                          src="@/assets/images/square_uncheck.svg"
                        >
                        <img v-else class="checkbox-square" src="@/assets/images/square_check.svg">
                        {{ list.name }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div v-if="all_attendees.length > 0" class="selected-list">
              <label class="text">All Attendees</label>
              <div class="clear" @click="clearList('all attendees','toggle_all_attendees')">
                <img src="@/assets/images/cancel.svg">
              </div>
            </div>
            <label v-if="static_selected.length > 0" class="list-title">Static Lists</label>
            <div class="selected-lists-container">
              <template v-for="static_list in static_selected">
                <div :key="static_list._id" class="selected-list">
                  <label class="text">
                    {{static_list.name}}
                    <span></span>
                  </label>
                  <div class="clear" @click="clearList(static_list, 'static')">
                    <img src="@/assets/images/cancel.svg">
                  </div>
                </div>
              </template>
            </div>
            <label v-if="smart_selected.length > 0" class="list-title">Smart Lists</label>
            <div class="selected-lists-container">
              <template v-for="smart_list in smart_selected">
                <div :key="smart_list._id" class="selected-list">
                  <label class="text">
                    {{smart_list.name}}
                    <span></span>
                  </label>
                  <div class="clear" @click="clearList(smart_list, 'smart')">
                    <img src="@/assets/images/cancel.svg">
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="mobile">
          <button class="btn btn-primary" @click="validate()">{{prizeAction}}</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import FullLoader from "@/components/FullLoader";
import Navbar from "@/components/Navbar";
import config from "@/config/config";
import { constants } from "fs";
var $ = require("jquery");
export default {
  name: "CreatePrize",
  data() {
    return {
      listname: "",
      display: true,
      showPrizeNameInfo: false,
      showWinnersInfo: false,
      showattendeesDropdownInfo: false,
      static_lists: [],
      smart_lists: [],
      all_attendees: [],
      static_selected: [],
      smart_selected: [],
      all_lists: [],
      prizeName: "",
      winnerCount: "",
      event_name: localStorage.getItem("event_name"),
      createLoading: false,
      errors: {
        emptyname: "",
        count: "",
        lists: "",
        lengthGreaterThanThirty: "",
        invalidName: ""
      },
      prize_name: ""
    };
  },
  props: ["editPrize", "button", "text"],
  components: {
    FullLoader,
    Navbar
  },
  computed: {
    getListUrl() {
      return (
        config.gevmeEndPoint +
        "/api/events/" +
        localStorage.getItem("event_id") +
        "/attendees/filters?access_token=" +
        localStorage.getItem("gevme_access_token")
      );
    },
    prizeAction() {
      return this.editPrize ? this.button : "Create Prize";
    },
    prizeText() {
      return this.editPrize ? this.text : "New Prize";
    },
    smart_lists_filter() {
      return this.smart_lists.filter(list => {
        return list.name.toLowerCase().includes(this.listname.toLowerCase());
      });
    },
    static_list_filter() {
      return this.static_lists.filter(list => {
        return list.name.toLowerCase().includes(this.listname.toLowerCase());
      });
    }
  },
  // watch: {
  //   static_selected: 'watchSingleList',
  //   smart_selected: 'watchSingleList',
  //   all_attendees: 'watchAllLists'
  // },
  methods: {
    validate() {
      const pattern = new RegExp("[^A-Za-z0-9 ]");
      this.errors.emptyname =
        this.prizeName.length === 0 ? "Prize name cannot be empty" : "";

      this.errors.lengthGreaterThanThirty =
        this.prizeName.length > 30
          ? "Prize name cannot be more than 30 characters"
          : "";

      this.errors.invalidName = pattern.test(this.prizeName)
        ? "Cannot contain special characters"
        : "";

      this.errors.count =
        this.winnerCount.length > 3 ||
        this.winnerCount.length === 0 ||
        String(this.winnerCount).includes("e") ||
        this.winnerCount === "0" ||
        String(this.winnerCount).includes(".")
          ? "Invalid winner count"
          : "";

      this.errors.lists =
        this.static_selected.length === 0 &&
        this.smart_selected.length === 0 &&
        this.all_attendees.length === 0
          ? "Select atleast one list"
          : "";
      if (
        this.errors.lengthGreaterThanThirty === "" &&
        this.errors.emptyname === "" &&
        this.errors.count === "" &&
        this.errors.lists === ""
      ) {
        this.createPrize();
      }
    },
    searchLists() {
      this.smart_lists.map(list => {
        list.display =
          list.name.toLowerCase().indexOf(this.listname.toLowerCase()) >= 0;
      });
      this.static_lists.map(list => {
        list.display =
          list.name.toLowerCase().indexOf(this.listname.toLowerCase()) >= 0;
      });
    },
    toggleHelperText(param) {
      switch (param) {
        case "prize_name":
          this.showPrizeNameInfo = !this.showPrizeNameInfo;
          break;
        case "winners":
          this.showWinnersInfo = !this.showWinnersInfo;
          break;
        case "attendees_dropdown":
          this.showattendeesDropdownInfo = !this.showattendeesDropdownInfo;
          break;
      }
    },

    watchSingleList() {
      // this.all_attendees = (this.static_lists.length + this.smart_lists.length) == (this.static_selected.length +
      // this.smart_selected.length) ? ["all_attendees"] : []
      if (
        this.static_lists.length + this.smart_lists.length ==
        this.static_selected.length + this.smart_selected.length
      ) {
        if (this.all_attendees.indexOf("all_attendees"))
          this.all_attendees.push("all_attendees");
      } else {
        this.all_attendees.length = 0;
      }
    },

    watchAllLists() {
      if (this.all_attendees.length == 0) {
        this.static_selected.length = 0;
        this.smart_selected.length = 0;
      } else {
        this.static_lists.forEach(element => {
          if (this.static_selected.indexOf(element) < 0) {
            this.static_selected.push(element);
          }
        });
        this.smart_lists.forEach(element => {
          if (this.smart_selected.indexOf(element) < 0) {
            this.smart_selected.push(element);
          }
        });
      }
    },
    backToDashboard() {
      this.$router.push("/");
    },
    clearList(param, list) {
      switch (list) {
        case "toggle_all_attendees":
          this.all_attendees.pop();
          break;
        case "static":
          if (this.static_selected.indexOf(param) > -1)
            this.static_selected.splice(this.static_selected.indexOf(param), 1);
          break;
        case "smart":
          if (this.smart_selected.indexOf(param) > -1)
            this.smart_selected.splice(this.smart_selected.indexOf(param), 1);
          break;
        default:
          break;
      }
    },

    createPrize() {
      this.callCreatePrize();
    },
    callCreatePrize() {
      this.createLoading = true;
      let listParams = [];
      if (this.all_attendees.length > 0) {
        listParams = [
          ...this.all_lists
            .filter(list => list.system_id == "all")
            .map(i => {
              return { id: i._id, name: i.name, type: i.type };
            }),
          ...this.static_selected.map(i => {
            return { id: i._id, name: i.name, type: i.type };
          }),
          ...this.smart_selected.map(i => {
            return { id: i._id, name: i.name, type: i.type };
          })
        ];
      } else {
        listParams = [
          ...this.static_selected.map(i => {
            return { id: i._id, name: i.name, type: i.type };
          }),
          ...this.smart_selected.map(i => {
            return { id: i._id, name: i.name, type: i.type };
          })
        ];
      }

      let paramString = "[";

      listParams.forEach(element => {
        paramString += `{id: \"${element.id}\", name: \"${
          element.name
        }\", type: \"${element.type}\"}, `;
      });
      paramString += "]";

      if (this.editPrize && this.prizeAction == "Update Prize") {
        axios
          .post(
            window.ENDPOINT,
            {
              query: `
                  mutation {
                    updatePrize(id:"${this.editPrize.id}", name:"${
                this.prizeName
              }", winnerCount: ${this.winnerCount},
                    lists: ${paramString} ) {
                      id
                      lists
                      name
                      winnerCount
                      author {
                        gevmeId
                        id
                      }
                    }
                  }
                `
            },
            {
              headers: {
                Authorization: localStorage.getItem("gevme_token")
              }
            }
          )
          .then(
            function(response) {
              this.createLoading = false;
              this.$router.push("/");
            }.bind(this)
          );
      } else {
        axios
          .post(
            window.ENDPOINT,
            {
              query: `
                mutation {
                  createPrize(name:"${this.prizeName}", winnerCount: ${
                this.winnerCount
              },
                  eventId: "${localStorage.getItem("event_id")}",
                  lists: ${paramString} ) {
                    id
                    lists
                    name
                    winnerCount
                    eventId
                    author {
                      gevmeId
                      id
                    }
                  }
                }
              `
            },
            {
              headers: {
                Authorization: localStorage.getItem("gevme_token")
              }
            }
          )
          .then(
            function(response) {
              this.createLoading = false;
              Event.$emit("Created Prize", response.data.data.createPrize);
              this.$router.push("/");
            }.bind(this)
          );
      }
    }
  },
  created() {
    Event.$on("Edit Prize", prize => {
      this.prizeName = prize.name;
      this.winnerCount = prize.winnerCount;
    });

    Event.$on("Error", () => {
      console.log("error");
    });

    Event.$on("Home clicked", () => {
      this.$router.push("/");
    });
  },
  mounted() {
    let title = "Create";
    if (this.editPrize) {
      this.prizeName = this.editPrize.name;
      this.winnerCount = this.editPrize.winnerCount;
      title = "Edit";
    }
    document.getElementsByTagName(
      "title"
    )[0].innerText = `${title} Prize • GEVME Lucky Draw`;

    axios.get(this.getListUrl).then(
      function(response) {
        this.all_lists.length = 0;
        this.static_lists.length = 0;
        this.smart_lists.length = 0;
        response.data.data.forEach(element => {
          this.all_lists.push(element);
        });
        response.data.data.forEach(element => {
          switch (element.type) {
            case "smartList":
              this.smart_lists.push(element);
              break;
            case "myList":
              this.static_lists.push(element);
              break;
            default:
              break;
          }
        });
        if (this.editPrize) {
          this.editPrize.lists.forEach(element => {
            if (element.type == "smartList") {
              this.smart_selected.push(
                this.smart_lists.filter(list => {
                  return list._id == element.id;
                })[0]
              );
            } else if (element.type == "myList") {
              this.static_selected.push(
                this.static_lists.filter(list => {
                  return list._id == element.id;
                })[0]
              );
            } else if (element.type == "system") {
              this.all_attendees.push("all_attendees");
            }
          });
        }
      }.bind(this)
    );

    $(".dropdown-menu.list-container").on("click", function(event) {
      var events = $._data(document, "events") || {};
      events = events.click || [];
      for (var i = 0; i < events.length; i++) {
        if (events[i].selector) {
          //Check if the clicked element matches the event selector
          if ($(event.target).is(events[i].selector)) {
            events[i].handler.call(event.target, event);
          }

          // Check if any of the clicked element parents matches the
          // delegated event selector (Emulating propagation)
          $(event.target)
            .parents(events[i].selector)
            .each(function() {
              events[i].handler.call(this, event);
            });
        }
      }
      event.stopPropagation(); //Always stop propagation
    });
  }
};
</script>

<style scoped>
.icon-info {
  cursor: pointer;
}

.caret-container {
  display: flex;
  position: absolute;
  top: 20px;
  right: 15px;
  cursor: pointer;
}
.attendees-dropdown-container {
  position: relative;
}
.caret-container > img {
  width: 14px;
  height: 9px;
  transform: rotate(180deg);
}

.checkbox > label {
  font-weight: 400;
  font-size: 12px;
  margin-bottom: auto;
  position: relative;
}

.checkbox > label > input {
  margin-right: 5px;
  opacity: 0;
  z-index: 2;
}

.list-container {
  padding: 15px;
}

.list-section {
  font-weight: bolder;
  color: #4f5f73;
  text-transform: uppercase;
  font-size: 12px;
  margin: 10px 0 3px 0;
}

label.list-title {
  font-size: 14px;
  text-transform: uppercase;
  color: #323c48;
}

.selected-lists-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 7px;
}

.selected-list {
  display: flex;
  align-items: center;
  margin: 0 20px 15px 0;
}

.selected-list > .text {
  font-size: 13px;
  color: #323c48;
  background-color: #d3e1ff;
  border-radius: 2px 0 0 2px;
  padding: 4px 10px 0 10px;
  height: 25px;
  margin: 0;
}

img.header-action.cancel {
  /* width: 17px;
    height: 17px; */
}

.selected-list > .clear {
  width: 25px;
  height: 25px;
  display: flex;
  background-color: #4e87fb;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.selected-list > .clear > img {
  width: 9px;
  height: 9px;
}

.checkbox-square {
  position: absolute;
  top: 3px;
  left: 1px;
}
img.header-action {
  position: absolute;
  left: -28px;
  cursor: pointer;
}
.error-message {
  font-size: 13px;
  color: red;
  font-weight: 300;
}
.checkbox:hover {
  background-color: rgba(220, 223, 231, 0.3);
}

.mobile {
  display: none;
}
@media screen and (max-width: 991px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}

@media screen and (max-width: 767px) {
  .create-prize-container.container {
    padding-left: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CreatePrize.vue